import type { UseFormProps } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { EXTERNAL_MANAGER_EMAIL_REGEX } from '@utils/YupUtil';

export type AddRequestFormData = {
  email: string;
};

export const useAddRequestForm = () => {
  const { t } = useTranslation();

  const addRequestSchema: Yup.SchemaOf<AddRequestFormData> = Yup.object().shape({
    email: Yup.string().required(t('Member_Manager_14')).matches(EXTERNAL_MANAGER_EMAIL_REGEX, t('Member_Manager_17')),
  });

  const addRequestFormOption: UseFormProps<AddRequestFormData> = {
    resolver: yupResolver(addRequestSchema),
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      email: '',
    },
  };
  return useForm<AddRequestFormData>(addRequestFormOption);
};
